import React, { useState, useContext, useEffect } from "react";
import { LockClosedIcon } from '@heroicons/react/solid'
import GetCustomerCode from "./GetCustomerCode";
import LoginToWebshop from "../fetch/LoginToWebshop";
import { Text, LanguageContext } from '../languages/Language';
import { ReactComponent as LogoutIcon } from '../assets/pic/logout.svg';
import { LOGO_LOGIN_BACKGROUND, setCurrency, setDecimalDigits, VERSION } from '../constants';
import fetchItemsFromAPI from "../fetch/fetchItemsFromAPI";
import fetchDataFromAPI from "../fetch/useFetchDataFromAPI";
import ReCAPTCHA from "react-google-recaptcha";
import { CONFIG } from "../config";
import { toast } from "react-toastify";
import { getCustomerCode } from "../fetch/getCustomerCode";
import { set } from "lodash";

//import ReactDOM from "react-dom";
//import PropTypes from 'prop-types';

function setToken(token) {
    sessionStorage.setItem('token', token);
}

function getToken() {
    const tokenString = sessionStorage.getItem('token');
    return tokenString;
}

export default function LoginModal({ setShowRegisterModal, onLogoutDeleteItemsAndCategories, onGetCategories, onGetItems, parentHandleToken, children }) {
    const [customerCode, setCustomerCode] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showModall, setshowModall] = React.useState(false);
    const [showCCModal, setShowCCModal] = React.useState(false);
    const [customerCodes, setCustomerCodes] = useState([]);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const logo = require(`../../vendors/${CONFIG.PROJECTNAME}/logo.png`);


    var token = getToken();

    const switchRegister = () => {
        setshowModall(false);
        setShowRegisterModal(true);
    }

    const [verified, setVerified] = useState(false);

    const onChange = (value) => {
        setVerified(true);
    };


    function handleLogout() {
        window.location.reload();
        setCustomerCode("")
        setEmail("")
        setPassword("")
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('paymentType');
        sessionStorage.removeItem('discRate');
        sessionStorage.removeItem('slipRef');
        sessionStorage.removeItem('items');
        sessionStorage.removeItem('allCategories');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('customerCode');
        sessionStorage.removeItem('Expl1');
        sessionStorage.removeItem('Expl2');
        //localStorage.clear();
        setToken("");
        setIsSubmitted(false);
        parentHandleToken(false);
        onLogoutDeleteItemsAndCategories()
    }

    useEffect(() => {
        if (customerCode !== "") {
            loginSite(customerCode, email, password);
        }
        
    }, [customerCode]);

    const handleSubmit = async event => {
        event.preventDefault();

        if (!verified) {
            alert("Please verify that you are not a robot.");
            return;
        }

        sessionStorage.setItem('email', email)
        sessionStorage.setItem('customerCode', customerCode)

        getCustomerCode(email, password)
            .then((customerCodes) => {
                if (customerCodes.resCode == 200 && customerCodes.dataSet) {

                    if (customerCodes.dataSet.length == 0) {
                        toast.error("No customer code found for the provided credentials.");
                        return;
                    }

                    else if (customerCodes.dataSet.length == 1) {
                        setCustomerCode(customerCodes.dataSet[0]["customerCode"]);
                    //    loginSite(customerCodes.dataSet[0]["customerCode"], email, password);
                        
                    }

                    else {
                        setCustomerCodes(customerCodes.dataSet);
                        console.log(customerCodes.dataSet);
                        setShowCCModal(true);
                    }

                } else {
                    toast.error(customerCodes.resMessage);
                }
            });

    };

    function loginSite(_customerCode, _email, _password){
        console.log("Logging in with customer code:", _customerCode);
        LoginToWebshop(_customerCode, _email, _password)
                            .then((json) => {
                                if (json.resCode == 200) {
                                    setCurrency(json.dataSet[0]["currency"])
                                    setDecimalDigits(json.dataSet[0]["decimalDigits"])
                                    fetchDataFromAPI(1306)
                                        .then(() => {
                                            onGetCategories()
                                            fetchItemsFromAPI(json.dataSet[0]?.token)
                                                .then(() => {
                                                    onGetItems()
                                                })
                                        });
                                    token = getToken();
                                    if (token) {
                                        setIsSubmitted(true);
                                        parentHandleToken(true);
                                    }
                                    toast.success(<Text tid="LoginSuccessfull" />, { hideProgressBar: true, autoClose: 2000 });
                                    console.log("Login successful");
                                } else {
                                    toast.error(json.resMessage);
                                }

                            })
    }

    const renderForm = (
        <>
            <button
                className=" items-center mx-0
                justify-center pt-1
                text-base font-bold  hover:opacity-75"
                type="button"
                onClick={() => setshowModall(true)}
            >
                {children ? children :
                    <Text tid="Login" />}
            </button>
            {showModall ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden
                        overflow-y-auto fixed inset-1 sm:inset-0 z-50 outline-none focus:outline-none"
                    >
                        <div
                            className="relative text-slate-900 w-auto "
                        >
                            {/*content*/}

                            <div
                                className={`border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none ${LOGO_LOGIN_BACKGROUND ? "bg-company-primary-color" : "bg-white"} `}
                            >
                                {/*header*/}
                                <div
                                    className="flex items-center justify-between px-10 pt-4 sm:px-4 sm:pt-2 border-b border-solid border-transparent rounded-t"
                                >
                                    <button
                                        className="flex items-center justify-center border-0 text-black opacity-50 float-right text-xl
                                        leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setshowModall(false)}
                                    >
                                        <span
                                            className={`bg-transparent h-7 w-7 text-xl inline-block align-text-top ${LOGO_LOGIN_BACKGROUND ? "text-white" : "text-company-primary-color"} hover:text-white-100`}
                                        >
                                            &#10006;
                                        </span>
                                    </button>
                                    <h3
                                        className="text-lg w-auto font-semibold text-white"
                                    >
                                    </h3>

                                </div>
                                {/*body*/}
                                <div
                                    className="relative flex-auto p-4 "
                                >
                                    <div
                                        className="pb-4 text-slate-500 text-lg leading-relaxed ">
                                        { /*----------------------------------------------------------------------------*/}

                                        <div className="h-auto flex flex-row items-center justify-center py-1 px-1 sm:px-1 lg:px-1">

                                            <div className="flex flex-col self-center space-y-1 justify-center items-center">
                                                <div className="w-64 justify-center items-center">
                                                    <div className={`justify-center items-center p-4`}>
                                                        <center><img className="" src={logo} alt="Logo" /> </center>
                                                    </div>
                                                </div>

                                                <form
                                                    className="mt-1 space-y-6 "
                                                    action="#"
                                                    method="POST"
                                                    onSubmit={handleSubmit}>
                                                    <input
                                                        type="hidden"
                                                        name="remember"
                                                        defaultValue="true"
                                                    />
                                                    <div
                                                        className="text-sm px-4"
                                                    >


                                                        <div className={`p-5 bg-site-color-3 rounded-md gap-2 border border-company-primary-color`}>

                                                            <div className=" py-1">
                                                                <label className="mt-2 "><Text tid="EmailAddress" /></label>
                                                                <input id="email-address" name="email" type="email" autoComplete="email" required
                                                                    className="w-full text-sm p-1 border bg-gray-50 border-gray-300 rounded focus:ring-0"
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className=" py-1">
                                                                <label className="mt-2"><Text tid="Password" /></label>
                                                                <input id="pass" name="pass" type="password" autoComplete="current-password"
                                                                    className="w-full text-sm p-1 border bg-gray-50 border-gray-300 rounded focus:ring-0"
                                                                    onChange={(e) => setPassword(e.target.value)}
                                                                    required />
                                                            </div>

                                                            {
                                                                showCCModal && (
                                                                    <GetCustomerCode
                                                                        data={customerCodes}
                                                                        selectCustomerCode={(code) => setCustomerCode(code)}
                                                                        setShowModal={setShowCCModal}
                                                                    />
                                                                )
                                                            }


                                                            <div className="py-1 pt-4 flex justify-center">
                                                                <ReCAPTCHA
                                                                    sitekey="6LdaJgssAAAAADf7hfxDCuHrrp0EtuoVm9pPelbr"
                                                                    onChange={onChange}
                                                                />
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div className="flex px-4 w-full items-center justify-center">
                                                        <button
                                                            type="submit"
                                                            className={`border-y-2 border-x-2 rounded-md   group relative w-full flex justify-center
                                                            font-medium bg-transparent  focus:outline-none focus:ring-2
                                                            ${LOGO_LOGIN_BACKGROUND ? 
                                                                "border-white text-white hover:text-white" : 
                                                                "border-company-primary-color text-company-primary-color hover:text-company-primary-color"}
                                                             focus:ring-slate-50
                                                            focus:ring-offset-2  items-center px-1 py-1 text-base shadow-sm hover:opacity-75`}                                                        >
                                                            <span
                                                                className="absolute left-0 inset-y-0 flex items-center pl-3"
                                                            >
                                                                <LockClosedIcon
                                                                    className={`h-5 w-5 ${LOGO_LOGIN_BACKGROUND ? "text-white" : "text-company-primary-color"} hover:opacity-75`}
                                                                    aria-hidden="true" />
                                                            </span>
                                                            <Text tid="SignIn" />
                                                        </button>

                                                    </div>
                                                    <div className={`flex flex-row justify-between px-4 h-2`}>
                                                        <div className={`${LOGO_LOGIN_BACKGROUND ? "text-white" : "text-company-primary-color"} text-xs text-center mt-1`}>
                                                            {VERSION}
                                                        </div>
                                                        {

                                                            <button onClick={() => switchRegister()}
                                                                className={`${LOGO_LOGIN_BACKGROUND ? "text-white" : "text-company-primary-color"} text-sm font-bold text-center hover:text-white-100`}><Text tid="Register" />
                                                            </button>

                                                        }

                                                    </div>

                                                </form>
                                            </div>

                                        </div>
                                        {/*-----------------------------------------------------------------------------------------*/}
                                    </div>
                                </div>
                                {/*footer*/}

                            </div>
                        </div>
                    </div>
                    <div
                        className="opacity-50 fixed inset-0 z-40 bg-black"
                    >
                    </div>
                </>
            ) : null}


        </>
    );

    const renderLogout = (
        <button
            className="flex w-28 lg:w-32 items-center
            rounded-md border border-transparent
            text-sm shadow-sm hover:opacity-75"
            type="button"
            onClick={() => handleLogout()}
        >
            <LogoutIcon className="w-6 h-6 fill-company-primary-color mx-1" />
            <Text tid="SignOff" />
        </button>
    );

    return (
        <div>
            {
                isSubmitted
                    ? renderLogout
                    : sessionStorage.getItem('token')
                        ? renderLogout
                        : renderForm
            }
        </div>
    );
}

